import { Controller } from "react-hook-form";
import CustomTextInput from "../../../ui/CustomTextInput/CustomTextInput";
import CustomLoader from "../../../ui/CustomLoader/CustomLoader";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { useShallow } from "zustand/shallow";
import useLipaBidhaaStore from "../../../../stores/lipaBidhaaStore";
import { PAYMENT_TYPE_FIELD_CONFIG } from "../../config/lipaBidhaaConfig";
import { ALIAS_VERIFICATION_STATUS } from "../../config/verificationStatus";

export function AliasInputField({
  control,
  aliasValidator,
  handleAliasChange,
  handleAliasBlur,
  isVerifying,
  isLoading,
}) {
  const { aliasVerificationStatus, aliasVerificationMessage, businessName, paymentType } =
    useLipaBidhaaStore(
      useShallow(({ aliasVerificationStatus, aliasVerificationMessage, businessName, paymentType }) => ({
        aliasVerificationStatus,
        aliasVerificationMessage,
        businessName,
        paymentType,
      })),
    );

  const { aliasLabel, aliasMaxLength, aliasNumericOnly } =
    PAYMENT_TYPE_FIELD_CONFIG[paymentType] ?? {};

  const isVerified =
    aliasVerificationStatus === ALIAS_VERIFICATION_STATUS.VERIFIED;
  const isUnverified =
    aliasVerificationStatus === ALIAS_VERIFICATION_STATUS.UNVERIFIED;

  return (
    <div className="space-y-1">
      <Controller
        name="alias"
        control={control}
        rules={{ validate: (v) => aliasValidator(v) ?? true }}
        render={({ field, fieldState }) => (
          <CustomTextInput
            label={aliasLabel}
            placeholder={aliasNumericOnly ? "400200" : "Enter Merchant Alias"}
            withAsterisk
            inputMode={aliasNumericOnly ? "numeric" : "text"}
            maxLength={aliasMaxLength}
            disabled={isVerifying || isLoading}
            rightSection={
              isVerifying ? <CustomLoader size={14} color="success" /> : null
            }
            value={field.value}
            onChange={(e) => {
              const value = aliasNumericOnly
                ? e.target.value.replaceAll(/\D/g, "").slice(0, aliasMaxLength)
                : e.target.value.slice(0, aliasMaxLength);
              field.onChange(value);
              useLipaBidhaaStore.getState().setPaymentDraft({ alias: value });
              handleAliasChange(value);
            }}
            onBlur={() => {
              field.onBlur();
              handleAliasBlur(field.value);
            }}
            error={fieldState.error?.message || (isUnverified ? true : undefined)}
          />
        )}
      />

      {isVerified && (
        <div className="flex items-center gap-1.5 px-1">
          <FaCheckCircle style={{ fontSize: 13 }} className="text-green-500 shrink-0" />
          <span className="text-xs text-green-600 font-medium">
            {businessName}
          </span>
        </div>
      )}

      {isUnverified && (
        <div className="flex items-center gap-1.5 px-1">
          <FaTimesCircle style={{ fontSize: 13 }} className="text-red-500 shrink-0" />
          <span className="text-xs text-red-500 font-medium">
            {aliasVerificationMessage || "Unverified"}
          </span>
        </div>
      )}
    </div>
  );
}
